import {ReactComponent as ErrorIcon} from './error.svg'

function Error() {
  return <ErrorIcon />
}

export default Error
